var indexOf = [].indexOf;

angular.module('gym.components').controller('CalendarFiltersModalCtrl', ["$scope", "$modalInstance", "locations", "instructors", "eventTypes", "styles", "selectedLocations", "selectedInstructors", "selectedEventTypes", "selectedStyles", "unableToManageOtherContacts", "disableShowAllInstructors", "hideInstructor", "multiSelect", "eventFilters", "eventFiltersMap", "params", function($scope, $modalInstance, locations, instructors, eventTypes, styles, selectedLocations, selectedInstructors, selectedEventTypes, selectedStyles, unableToManageOtherContacts, disableShowAllInstructors, hideInstructor, multiSelect, eventFilters, eventFiltersMap, params) {
  $scope.locations = locations;
  $scope.instructors = instructors;
  $scope.eventTypes = eventTypes;
  $scope.styles = styles;
  $scope.eventFilters = eventFilters;
  $scope.eventFiltersMap = eventFiltersMap;
  $scope.params = params;
  $scope.multiSelect = multiSelect;
  $scope.unableToManageOtherContacts = unableToManageOtherContacts;
  $scope.disableShowAllInstructors = disableShowAllInstructors;
  $scope.hideInstructor = hideInstructor;
  $scope.data = {
    selectedLocations: selectedLocations.map(function(item) {
      return item.id;
    }),
    selectedInstructors: selectedInstructors.map(function(item) {
      return item.id;
    }),
    selectedEventTypes: selectedEventTypes.map(function(item) {
      return item.id;
    }),
    selectedStyles: selectedStyles.map(function(item) {
      return item.id;
    })
  };
  $scope.submit = function() {
    var data;
    data = {};
    data.general_filter = $scope.params.general_filter;
    data.locations = locations.filter(function(item) {
      var ref;
      return ref = item.id, indexOf.call($scope.data.selectedLocations, ref) >= 0;
    });
    data.eventTypes = eventTypes.filter(function(item) {
      var ref;
      return ref = item.id, indexOf.call($scope.data.selectedEventTypes, ref) >= 0;
    });
    data.styles = styles.filter(function(item) {
      var ref;
      return ref = item.id, indexOf.call($scope.data.selectedStyles, ref) >= 0;
    });
    if (!hideInstructor && !unableToManageOtherContacts) {
      data.instructors = instructors.filter(function(item) {
        var ref;
        return ref = item.id, indexOf.call($scope.data.selectedInstructors, ref) >= 0;
      });
    }
    return $modalInstance.close(data);
  };
  return $scope.cancel = function() {
    return $modalInstance.dismiss('cancel');
  };
}]);
